'use client';

import { useQuery } from '@tanstack/react-query';
import type { GWPDiscount } from '@veranda/shared/lib/api-handlers/promotional-products';

export interface GWPResponse {
  success: boolean;
  data: GWPDiscount | null;
  message?: string;
}

export function useGWPDiscount(discountId?: string) {
  return useQuery({
    queryKey: ['gwp-discount', discountId],
    queryFn: async (): Promise<GWPResponse> => {
      if (!discountId) {
        return {
          success: false,
          data: null,
          message: 'No discount ID provided',
        };
      }

      const response = await fetch(
        `/api/shopify/promotional-products?discountId=${discountId}`
      );

      if (!response.ok) {
        return {
          success: false,
          data: null,
          message: 'Failed to fetch GWP data',
        };
      }

      return response.json();
    },
    enabled: !!discountId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
